






























































































































































































// @ts-ignore
import v8n from 'v8n';
import moment from 'moment';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { authModule, bookingModule } from '@/store';
import { Quote, Lot } from '@/api';

@Component({
  components: {},
})
export default class extends Vue {
  quotes: Quote[] = [];

  loading: boolean = false;
  valid: boolean = false;

  startDateMenu: boolean = false;
  endDateMenu: boolean = false;

  autoEndUpdated: boolean = false;

  activeLot: Lot | null = null;

  futureDate = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .futureDate()
        .test(v) || 'Date must be in the future.',
  ];

  returnDate = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .endDate()
        .test(v) || 'Date must be after the departure date.',
  ];

  get startDate() {
    if (!bookingModule.startDate) {
      return null;
    }
    return bookingModule.startDate;
  }
  set startDate(date: string | null) {
    bookingModule.setStartDate(date);
  }

  get endDate() {
    if (!bookingModule.endDate) {
      return null;
    }
    return bookingModule.endDate;
  }
  set endDate(date: string | null) {
    bookingModule.setEndDate(date);
  }

  get formattedStartDate() {
    if (!this.startDate) {
      return '';
    }
    return moment(this.startDate, 'YYYY-MM-DD').format('D/M/YYYY');
  }

  get formattedEndDate() {
    if (!this.endDate) {
      return '';
    }
    return moment(this.endDate, 'YYYY-MM-DD').format('D/M/YYYY');
  }

  get outdoorQuote() {
    if (!this.quotes) {
      return;
    }
    return this.quotes.find((quote: Quote) => quote.lot.slug === 'outdoor');
  }

  get indoorQuote() {
    if (!this.quotes) {
      return;
    }
    return this.quotes.find((quote: Quote) => quote.lot.slug === 'indoor');
  }

  get hasIndoorSubscription() {
    return authModule.activeIndoorSubscription;
  }

  get hasOutdoorSubscription() {
    return authModule.activeOutdoorSubscription;
  }

  updateEndDate() {
    if (moment(this.startDate).diff(moment(this.endDate), 'days') > 0) {
      this.autoEndUpdated = true;
      this.endDate = this.startDate;
    }
  }

  setLot(lot: Lot) {
    this.activeLot = lot;
  }

  step1() {
    if (!this.activeLot) {
      return;
    }

    if (bookingModule.booking) {
      bookingModule.booking.lot = this.activeLot;
      const quote = this.quotes.find((q: Quote) => {
        if (!this.activeLot) {
          return;
        }
        return q.lot.slug === this.activeLot.slug;
      });
      if (quote) {
        bookingModule.setParkingPrice(quote.price);
      }

      bookingModule.setCompletedStep(1);

      this.$router.push({
        name: 'booking-step-2',
      });
    }
  }

  async updateQuote() {
    if (!this.startDate || !this.endDate) {
      return;
    }
    try {
      this.loading = true;
      this.quotes = (
        await Quote.extraParams({
          start_date: this.startDate,
          end_date: this.endDate,
        })
          .where({
            lot_slug__in: ['indoor', 'outdoor'],
          })
          .includes(['lot'])
          .all()
      ).data;
    } catch (err) {
      // Error
    } finally {
      this.loading = false;
      if (this.activeLot) {
        const activeQuote = this.quotes.find((quote: Quote) => {
          if (!this.activeLot) {
            return;
          }
          return quote.lot.slug === this.activeLot.slug;
        });
        if (activeQuote && activeQuote.fillThresholdExceeded) {
          this.activeLot = null;
        }
      } else {
        if (this.outdoorQuote && !this.outdoorQuote.fillThresholdExceeded) {
          this.activeLot = this.outdoorQuote.lot;
        }
      }
    }
  }

  beforeMount() {
    const futureDate = () => {
      return (value: string) =>
        moment(value, 'D/M/YYYY').diff(moment(), 'days') >= 0;
    };
    const endDate = () => {
      return (value: string) =>
        moment(value, 'D/M/YYYY').diff(moment(this.startDate), 'days') >= 0;
    };
    v8n.extend({ futureDate, endDate });
  }

  mounted() {
    bookingModule.setCurrentStep(1);

    this.updateQuote();
  }

  @Watch('formattedStartDate')
  startDateChanged(val: string, oldVal: string) {
    let isValid;
    try {
      this.futureDate.forEach(f => {
        const valid = f(val);
        if (valid !== true) {
          throw valid;
        }
      });
      isValid = true;
    } catch (err) {
      isValid = false;
    } finally {
      if (isValid) {
        this.updateQuote();
      }
    }
  }

  @Watch('formattedEndDate')
  endDateChanged(val: string, oldVal: string) {
    if (!this.autoEndUpdated) {
      let isValid;
      try {
        this.returnDate.forEach(f => {
          const valid = f(val);
          if (valid !== true) {
            throw valid;
          }
        });
        isValid = true;
      } catch (err) {
        isValid = false;
      } finally {
        if (isValid) {
          this.updateQuote();
        }
      }
    } else {
      this.autoEndUpdated = false;
    }
  }
}
